// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 660) return "/js/vendor.js";
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"76":"35bad221","308":"f564336f","394":"580f8f1b","487":"645ab222","711":"2c4f74fa","779":"01f22b8b"}[chunkId] + ".js";
};